import { render } from "./YourDetailsDefault.vue?vue&type=template&id=21a9caa2&scoped=true"
import script from "./YourDetailsDefault.vue?vue&type=script&lang=js"
export * from "./YourDetailsDefault.vue?vue&type=script&lang=js"

import "./YourDetailsDefault.vue?vue&type=style&index=0&id=21a9caa2&lang=scss"
import "./YourDetailsDefault.vue?vue&type=style&index=1&id=21a9caa2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a9caa2"]])

export default __exports__